export default __webpack_public_path__ + "static/media/br-clock.89d9ea2f.svg";